export const info = {
  title: "CatNet® Risk Assessment Report",
  author: "Swiss Re",
  subject: "CatNet® Risk Assessment Report",
  keywords: "catnet risk assessment report",
  producer: "Swiss Re",
  creator: "Swiss Re"
};
